import { PointCardForm } from 'src/components/model/pointCard/form';

export const PointCardCreateForm: React.FC = () => {
  return <PointCardForm />;
};
